import React, { useState, useEffect } from "react";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { fetchData } from "../../utility/adminApi";
import useDefaultCurrency from "../../utility/useDefaultCurrency";
import LowStockTableBody from "./LowStockTableBody";
import loader from "../../assets/loader.webp";

function LowStock() {
  const { data } = useDefaultCurrency("admin");
  const [currency, setCurrency] = useState(null);
  const [lowstockData, setLowstockData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [, setTotalPage] = useState(1);
  const [, setIsPrevLoading] = useState(false);
  const [, setIsNextLoading] = useState(false);

  const [searchData, setSearchData] = useState("");

  const handleChange = async (e) => {
    setSearchData(e.target.value);
  };

  const fetchLowstock = async (page = 1, search = "") => {
    const response = await fetchData(
      "products/low_stock",
      currentPage,
      searchData
    );
    setLowstockData(response?.data || []);

    setTotalPage(response?.data?.last_page ? response?.data?.last_page : 1);
    setIsLoading(false);
    setIsNextLoading(false);
    setIsPrevLoading(false);
  };

  // Fetch data on page change or search query change
  useEffect(() => {
    fetchLowstock(currentPage, searchData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, searchData]);
  useEffect(() => {
    setCurrentPage(1);
    fetchLowstock(currentPage, searchData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);

  useEffect(() => {
    setCurrency(data?.currency?.symbol);
  }, [data]);

  return (
    <div className="lg:overflow-y-hidden ">
      {/* Header */}
      <div className="flex justify-between mb-4 items-center">
        <h3 className="text-xl font-semibold">
          <ShowChartIcon /> Low Stock{" "}
        </h3>
        <div className="flex  flex-wrap"></div>
      </div>
      <div className=" bg-white flex flex-col lg:justify-normal w-full lg:gap-3 overflow-x-auto items-center py-6 px-8">
        <div className="flex flex-col lg:flex-row justify-between items-center w-full">
          <div>
            {/* Consider resarching for MUI UI search bar  */}
            <input
              type="text"
              className="border-2 border-gray-400 w-60 p-2 px-6"
              placeholder="Search "
              value={searchData}
              onChange={handleChange}
            />
          </div>
        </div>

        {isLoading ? (
          <div className="  flex justify-center items-center">
            {" "}
            <img src={loader} alt="loader" className=" w-10 lg:w-20 " />{" "}
          </div>
        ) : (
          <div className="w-full">
            <table className="min-w-full bg-white border border-gray-300">
              <thead>
                <tr className="bg-gray-200">
                  <th className="py-2 px-4 border-b border-gray-300">IMAGE</th>
                  <th className="py-2 px-4 border-b border-gray-300">
                    PRODUCT NAME
                  </th>
                  <th className="py-2 px-4 border-b border-gray-300">STOCK</th>
                  <th className="py-2 px-4 border-b border-gray-300">PRICE</th>
                  <th className="py-2 px-4 border-b border-gray-300">
                    CATEGORY
                  </th>
                  <th className="py-2 px-4 border-b border-gray-300 text-wrap">
                    ACTIONS
                  </th>
                </tr>
              </thead>
              <LowStockTableBody
                lowstockData={lowstockData}
                currency={currency}
                fetchLowstock={fetchLowstock}
              />
            </table>
            {/* For Pagination */}
            {/* <Pagination
              onPageChange={handleCurrentPage}
              totalPage={totalPage}
              currentPage={currentPage}
              setIsNextLoading={setIsNextLoading}
              setIsPrevLoading={setIsPrevLoading}
              isPrevLoading={isPrevLoading}
              isNextLoading={isNextLoading}
            /> */}
          </div>
        )}
      </div>
    </div>
  );
}

export default LowStock;
